import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalFooter,
  MDBModalHeader,
  MDBSelect,
  MDBInput,
} from "mdbreact";
import {
  showHideLoader,
  showNotification,
  toggleModal,
} from "../../../../actions";
import DatePicker from "react-datepicker";

import _ from "lodash";
import { useEffect } from "react";
import moment from "moment";
import {
  getLocationByUuidApi,
  getLocations,
} from "../../../../apis/LocationApi";
import { createBlock, updateBlock } from "../../../../apis/CalendarBlockingApi";
import { clearError } from "../../../../helper/ValidationHelper";

function CalendarBookingModal({
  showModal,
  onClose,
  initialState,
  isEdit = false,
  locationOptions,
}) {
  const dispatch = useDispatch();

  const [blockPayload, setBlockPayload] = useState(() => ({ ...initialState }));
  const [slots, setSlots] = useState([]);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [blockPayloadError, setBlockPayloadError] = useState({});
  const [location, setLocation] = useState({});
  const [resources, setResources] = useState([]);
  const [isUpdate, setIsUpdate] = useState(isEdit);

  const handleClose = () => {
    onClose();
    const modal = {
      isOpen: false,
    };
    dispatch(toggleModal(modal));
    setSlots([]);
  };

  function generateTimeSlots(startTime, endTime, intervalMinutes = 30) {
    const parseTime = (time) => {
      const [timePart, modifier] = time.split(" ");
      let [hours, minutes] = timePart.split(":").map(Number);

      if (modifier === "PM" && hours !== 12) hours += 12;
      if (modifier === "AM" && hours === 12) hours = 0;

      return hours * 60 + minutes;
    };

    const formatTime = (minutes) => {
      const hrs24 = Math.floor(minutes / 60) % 24;
      const mins = minutes % 60;

      return `${hrs24.toString().padStart(2, "0")}:${mins
        .toString()
        .padStart(2, "0")}`;
    };

    let start = parseTime(startTime);
    let end = parseTime(endTime);

    // handle crossing midnight
    if (end <= start) {
      end += 24 * 60;
    }

    const slots = [];

    for (let current = start; current < end; current += intervalMinutes) {
      const from = formatTime(current);
      const to = formatTime(current + intervalMinutes);
      slots.push({ timeFrom: from, timeTo: to });
    }

    return slots;
  }

  const addResourceId = (values) => {
    if (!values) return;
    const nextIds = resources
      .filter((opt) => {
        return values.includes(opt.id);
      })
      .map((opt) => opt.id);

    setBlockPayload((prev) => {
      if (
        prev.resourceIds.length === nextIds.length &&
        prev.resourceIds.every((id) => nextIds.includes(id))
      ) {
        return prev;
      }
      return {
        ...prev,
        resourceIds: nextIds,
      };
    });
  };
  const handleResourceOptions = (resourcesAsArray, selectedResourceIds) => {
    if (!resourcesAsArray) return;

    const options = [];
    for (const resource of resourcesAsArray) {
      const option = {
        text: resource.name,
        value: resource.id,
        checked: selectedResourceIds
          ? selectedResourceIds.includes(resource.id)
          : false,
      };
      options.push(option);
    }
    return options;
  };

  const validate = () => {
    const nextErrors = {};
    if (!location) {
      nextErrors.locationId = "Location is required";
    }
    if (!blockPayload.resourceIds || blockPayload.resourceIds.length === 0) {
      nextErrors.resourceIds = "Resource is required. Select at least one";
    }
    if (!blockPayload.blockDate) {
      nextErrors.blockDate = "Block Date is required";
    }
    if (!blockPayload.timeFrom) {
      nextErrors.timeFrom = "Start time is required";
    }

    if (!blockPayload.timeTo) {
      nextErrors.timeTo = "End time is required";
    }

    setBlockPayloadError(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // 🚫 page reload
    if (!validate()) return;
    if (submitting) return;

    setSubmitting(true);
    setError(null);
    dispatch(showHideLoader(true));

    try {
      const payload = {
        local_time_from: blockPayload.timeFrom,
        local_time_to: blockPayload.timeTo,
        reason: blockPayload.reason,
        name: blockPayload.name,
        resource_ids: blockPayload.resourceIds,
        location_id: location.id,
        block_date: moment(blockPayload.blockDate).format("YYYY-MM-DD"),
      };
      let response;
      if (isUpdate) {
        response = await updateBlock(blockPayload.uuid, payload);
      } else {
        response = await createBlock(payload);
      }
      dispatch(showNotification("success", response.data.message));
      handleClose();
    } catch (err) {
      dispatch(showNotification("error", err.data.message));
    } finally {
      setSubmitting(false);
      dispatch(showHideLoader(false));
    }
  };

  useEffect(() => {
    if (!showModal) return;
    const slots = generateTimeSlots("7:00 AM", "11:00 PM");
    setSlots(slots);
  }, [showModal]);

  useEffect(() => {
    if (showModal && initialState) {
      setBlockPayload({ ...initialState });
    }
    setIsUpdate(isEdit);
  }, [showModal, initialState, isEdit]);

  useEffect(() => {
    if (!locationOptions || locationOptions.length <= 0) return;

    const currentLocation = locationOptions.find((x) => x.checked);
    const resourcesAsArray = [];
    Object.entries(currentLocation.value.resources).map(([key, resource]) =>
      resourcesAsArray.push(resource),
    );
    setResources(resourcesAsArray);
    setLocation(currentLocation.value);
  }, [showModal, locationOptions]);

  return (
    <>
      <div className="child-popup">
        <MDBModal isOpen={showModal} size="lg" toggle={() => handleClose()}>
          <MDBModalBody>
            <MDBModalHeader>
              <h3>
                {!isEdit
                  ? "Create Blocking Resource"
                  : "Modify Blocking Resource "}
              </h3>
            </MDBModalHeader>
            <form onSubmit={handleSubmit}>
              <MDBModalBody>
                <MDBRow className="md-2">
                  <MDBCol md="6">
                    <label htmlFor="name" className="grey-text">
                      Block Name
                    </label>
                    <MDBInput
                      className=""
                      id="name"
                      outline
                      color="primary"
                      value={blockPayload.name}
                      onChange={(e) => {
                        if (!e.target.value) return;

                        setBlockPayload((payload) => ({
                          ...payload,
                          name: e.target.value,
                        }));
                      }}
                    />
                  </MDBCol>

                  <MDBCol md="6">
                    <label htmlFor="location_id" className="grey-text">
                      <span className="text-danger">*</span> Location ID
                    </label>
                    <MDBSelect
                      id="location_id"
                      outline
                      color="primary"
                      options={locationOptions}
                      getValue={(val) => {
                        if (!val || val.length <= 0) return;
                        const resourcesAsArray = [];
                        Object.entries(val[0].resources).map(
                          ([key, resource]) => resourcesAsArray.push(resource),
                        );
                        setResources(resourcesAsArray);
                        setLocation(val[0]);
                      }}
                    />

                    {blockPayloadError.locationId && (
                      <small className="text-danger">
                        {blockPayloadError.locationId}
                      </small>
                    )}
                  </MDBCol>
                </MDBRow>
                <MDBRow className="md-2">
                  <MDBCol
                    md="6"
                    style={{
                      paddingRight: "5px",
                      paddingLeft: "5px",
                      marginBottom: "1.5rem",
                    }}
                  >
                    <label
                      htmlFor="block_date"
                      className="grey-text"
                      style={{
                        marginBottom: "1.5rem",
                      }}
                    >
                      <span className="text-danger">*</span> Block Date{" "}
                    </label>
                    <DatePicker
                      className="custom-input"
                      id="block_date"
                      minDate={new Date()}
                      clear
                      selected={blockPayload.blockDate}
                      dateFormat="dd/MM/yyyy"
                      onChange={(value) => {
                        if (!value) return;
                        setBlockPayload((payload) => ({
                          ...payload,
                          blockDate: value,
                        }));
                        setBlockPayloadError((prev) =>
                          clearError(prev, "blockDate"),
                        );
                      }}
                    />

                    {blockPayloadError.blockDate && (
                      <small className="text-danger">
                        {blockPayloadError.blockDate}
                      </small>
                    )}
                  </MDBCol>

                  <MDBCol md="6">
                    <label htmlFor="resource_ids" className="grey-text">
                      <span className="text-danger">*</span> Resources{" "}
                    </label>
                    <MDBSelect
                      multiple
                      outline
                      color="primary"
                      id="resource_ids"
                      options={handleResourceOptions(
                        resources,
                        blockPayload.resourceIds,
                      )}
                      getValue={(val) => {
                        if (!val || !val.length) return;
                        handleResourceOptions(resources, val);
                        addResourceId(val);
                        setBlockPayloadError((prev) =>
                          clearError(prev, "resourceIds"),
                        );
                      }}
                    />
                    {blockPayloadError.resourceIds && (
                      <small className="text-danger">
                        {blockPayloadError.resourceIds}
                      </small>
                    )}
                  </MDBCol>
                </MDBRow>
                <MDBRow className="md-2">
                  <MDBCol md="6">
                    <label htmlFor="start_time" className="grey-text">
                      <span className="text-danger">*</span> Block Start
                      Time{" "}
                    </label>
                    <MDBSelect
                      outline
                      options={slots.map((s) => ({
                        text: s.timeFrom,
                        value: s.timeFrom,
                      }))}
                      id="start_time"
                      selected={blockPayload.timeFrom && blockPayload.timeFrom}
                      getValue={(value) => {
                        if (!value || !value.length) return;
                        const selected = value[0]; // always use index 0
                        setBlockPayload((payload) => ({
                          ...payload,
                          timeFrom: selected,
                          timeTo: "",
                        }));
                        setBlockPayloadError((prev) => {
                          let next = prev;
                          next = clearError(next, "timeFrom");
                          return next;
                        });
                      }}
                    />
                    {blockPayloadError.timeFrom && (
                      <small className="text-danger">
                        {blockPayloadError.timeFrom}
                      </small>
                    )}
                  </MDBCol>
                  <MDBCol md="6">
                    <label htmlFor="end_time" className="grey-text">
                      <span className="text-danger">*</span> Block End Time
                    </label>
                    <MDBSelect
                      outline
                      id="end_time"
                      options={slots
                        .filter(
                          (s) =>
                            !blockPayload.timeFrom ||
                            s.timeFrom >= blockPayload.timeFrom,
                        )
                        .map((s) => ({
                          text: s.timeTo,
                          value: s.timeTo,
                        }))}
                      selected={blockPayload.timeTo && blockPayload.timeTo}
                      getValue={(value) => {
                        if (!value || !value.length) return;

                        const selected = value[0]; // always use index 0
                        setBlockPayload((payload) => ({
                          ...payload,
                          timeTo: selected,
                        }));
                        setBlockPayloadError((prev) =>
                          clearError(prev, "timeTo"),
                        );
                      }}
                    />
                    {blockPayloadError.timeTo && (
                      <small className="text-danger">
                        {blockPayloadError.timeTo}
                      </small>
                    )}
                  </MDBCol>
                </MDBRow>
                <MDBRow className="md-2">
                  <MDBCol md="12">
                    <label htmlFor="reason" className="grey-text">
                      Reason{" "}
                    </label>
                    <MDBInput
                      outline
                      type="textarea"
                      id="reason"
                      rows="4"
                      value={blockPayload.reason}
                      onChange={(e) => {
                        setBlockPayload((payload) => ({
                          ...payload,
                          reason: e.target.value,
                        }));
                      }}
                    />
                  </MDBCol>
                </MDBRow>
                <MDBRow className="md-2">
                  {error && <small className="text-danger">{error}</small>}
                </MDBRow>
              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn type="submit" disabled={submitting} color="primary">
                  {submitting ? "Saving..." : "Submit"}
                </MDBBtn>
                <MDBBtn color="secondary" onClick={() => handleClose()}>
                  Close
                </MDBBtn>
              </MDBModalFooter>
            </form>
          </MDBModalBody>
        </MDBModal>
      </div>
    </>
  );
}

export default CalendarBookingModal;
